import { PayloadAction } from '@reduxjs/toolkit';
import dotPropImmutable from 'dot-prop-immutable';
import uniq from 'lodash/uniq';
import { ResourceSectionType } from 'data/documents';
import {
  CreateDocumentResourceSectionPayload,
  UpdateDocumentResourceSectionPayload,
} from '../actions';
import {
  DocumentTemplateStore,
  DocumentTemplateContentSection,
} from '../types';

export const documentTemplateResourceSlice = {
  createDocumentResourceSection: (
    state: DocumentTemplateStore,
    { payload }: PayloadAction<CreateDocumentResourceSectionPayload>,
  ): DocumentTemplateStore => {
    const {
      docId,
      resourceSectionId,
      resourceSectionName,
      resourceType,
      sectionId: _sectionId,
    } = payload;

    const sections: DocumentTemplateContentSection[] = Object.values(
      dotPropImmutable.get(state, `${docId}.sections`, {}),
    );

    const sectionId =
      _sectionId !== undefined
        ? _sectionId
        : sections.find((section) => {
            return section.meta.sectionType === 'PUBLIC';
          })?.documentSectionId;

    const newResourceSection = {
      resourceSectionId,
      resourceSectionName,
      resourceSectionType: ResourceSectionType.Task,
      resourceType,
      resourceIds: [],
      resourceObjects: [],
    };

    const resourceSectionIds = dotPropImmutable.get(
      state,
      `${docId}.sections.${sectionId}.meta.resourceSections`,
      [],
    );

    let result = dotPropImmutable.set(
      state,
      `${docId}.sections.${sectionId}.meta.resourceSections`,
      uniq([...resourceSectionIds, resourceSectionId]),
    );

    result = dotPropImmutable.merge(
      result,
      `${docId}.resourceSections.${resourceSectionId}`,
      newResourceSection,
    );

    return result;
  },

  updateDocumentResourceSection: (
    state: DocumentTemplateStore,
    { payload }: PayloadAction<UpdateDocumentResourceSectionPayload>,
  ): DocumentTemplateStore => {
    const { docId, resource } = payload;

    return dotPropImmutable.merge(
      state,
      `${docId}.resourceSections.${resource.resourceSectionId}`,
      resource,
    );
  },
};
